import { api, handleResponse } from "@/api/config";

export const teamService = {
  /* =========================================
     GET ALL TEAMS
  ========================================= */

  getAll: async (params) => {
    const res = await api.get("/teams", {
      params,
    });

    return handleResponse(res);
  },

/* =========================================
   BACKWARD COMPATIBILITY
========================================= */

getTeams(params) {
  return this.getAll(params);
},

  /* =========================================
     GET TEAM STATS
  ========================================= */

  getStats: async () => {
    const res = await api.get("/teams/stats");

    return handleResponse(res);
  },

  /* =========================================
     GET SINGLE TEAM
  ========================================= */

  getById: async (id) => {
    const res = await api.get(`/api/teams/${id}`);

    return handleResponse(res);
  },

  /* =========================================
     GET TEAMS BY DEPARTMENT
  ========================================= */

  getByDepartment: async (department) => {
    const res = await api.get(
      `/api/teams/department/${department}`
    );

    return handleResponse(res);
  },

  /* =========================================
     GET USER TEAMS
  ========================================= */

  getUserTeams: async (userId) => {
    const endpoint = userId
      ? `/api/teams/user/${userId}`
      : `/api/teams/user`;

    const res = await api.get(endpoint);

    return handleResponse(res);
  },

  /* =========================================
     CREATE TEAM
  ========================================= */

  create: async (data) => {
    const res = await api.post(
      "/teams",
      data
    );

    return handleResponse(res);
  },

  /* =========================================
     UPDATE TEAM
  ========================================= */

  update: async (id, data) => {
    const res = await api.put(
      `/api/teams/${id}`,
      data
    );

    return handleResponse(res);
  },

  /* =========================================
     UPDATE TEAM MEMBERS
  ========================================= */

  updateMembers: async (
    teamId,
    memberIds
  ) => {
    const res = await api.put(
      `/api/teams/${teamId}/members`,
      {
        memberIds,
      }
    );

    return handleResponse(res);
  },

  /* =========================================
     DELETE TEAM
  ========================================= */

  delete: async (id) => {
    const res = await api.delete(
      `/api/teams/${id}`
    );

    return handleResponse(res);
  },
};

export default teamService;
